$('.truncated').each(function(){
    var el = $(this);

    if(!el.find('.truncated_full_value')) { return; }

    var div = el.find('.truncated_full_value');
    var dd = div.find('dd');

    el.replaceWith(dd);
});